import React, { useEffect } from "react";
import CryptoPayment from "./crypto-payment";
import MassPay from "./mass-pay";
import { useDispatch } from "react-redux";
import { getPayeeData } from "../../../../store/actions";
import { paymentOptions, TRANSFER_MODE } from "../../../../utils/constants";
import Pockyt from "./pockyt";
import XBD from "./xbd";

export default function RenderSteps({ type, active,
  amount,
  setActive,
  setShowKyt,
  setShowKytBlocked,
  step }) {

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPayeeData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  switch (type) {
    case paymentOptions.crypto:
      return <CryptoPayment active={active} amount={amount} setActive={setActive} setShowKyt={setShowKyt} setShowKytBlocked={setShowKytBlocked} step={step} />
    case paymentOptions.masspay:
      return <MassPay active={active} amount={amount} setActive={setActive} setShowKyt={setShowKyt} setShowKytBlocked={setShowKytBlocked} step={step} />;
    case paymentOptions.pockyt:
      return <Pockyt active={active} amount={amount} setActive={setActive} setShowKyt={setShowKyt} setShowKytBlocked={setShowKytBlocked} step={step} mode={TRANSFER_MODE} />;
    case paymentOptions.xbd:
      return <XBD active={active} amount={amount} setActive={setActive} setShowKyt={setShowKyt} setShowKytBlocked={setShowKytBlocked} step={step} mode={TRANSFER_MODE}/>;
    default:
      return <></>
  }
}